import React from "react";
import Esther_Wanjiku_profile from "../../Assets/Esther_Wanjiku_profile1.jpg";
export default function HeaderSection(){
    return(
        <section id="heroSection" className="hero--section mt-20 grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 lg:grid-cols-2 mt-12">
           <div className="hero--section--content--box">
             <div className="hero--section--content">
               <p className="hero--section-description ">Hi i am Esther Wanjiku</p>               
                 <span className="hero--section-description"> A full  Stack  developer.Learning new technologies</span>                        
               <p className="hero--section-description">Ready to challenge myself to build something great</p>
               <p className="hero--section-description">using the most updated technologies  to create solutions for everyday life and learning from past  challenges
               </p>
             </div>
              <button className=" bg-blue-500 rounded-lg w-28 h-16"> <a href="https://www.linkedin.com/in/esther-wanjiku-3054722b4/">Get In Touch</a></button>
           </div>
           <div className="hero--section--img">
            <img className=" w-full h-[300px] rounded-lg " src="https://media.licdn.com/dms/image/v2/D4D16AQEzgGvnvQ9lPw/profile-displaybackgroundimage-shrink_350_1400/B4DZXo5jHlH4Ac-/0/1743369159722?e=1757548800&v=beta&t=zMh7Qf_5UwR8EdkWcgsecJjn62EnQTfE-TOc_XMRi30"
            
             alt="heroSection" />
           </div>
        </section>
    )

}